import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

export const ThemePreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{tala.50}',
      100: '{tala.100}',
      200: '{tala.200}',
      300: '{tala.300}',
      400: '{tala.400}',
      500: '{tala.500}',
      600: '{tala.600}',
      700: '{tala.700}',
      800: '{tala.800}',
      900: '{tala.900}',
      950: '{tala.950}',
    },
    colorScheme: {
      light: {
        surface: {
          0: '#ffffff',
          50: '{tala.50}',
          100: '{tala.100}',
          200: '{tala.200}',
          300: '{tala.300}',
          400: '{tala.400}',
          500: '{tala.500}',
          600: '{tala.600}',
          700: '{tala.700}',
          800: '{tala.800}',
          900: '{tala.900}',
          950: '{tala.950}',
        },
        primary: {
          color: '{tala.500}',
          contrastColor: '#ffffff',
          hoverColor: '{tala.400}',
          activeColor: '{tala.600}',
        },
        highlight: {
          background: '{tala.500}',
          focusBackground: '{tala.600}',
          color: '#ffffff',
          focusColor: '#ffffff',
        },
      },
      dark: {
        surface: {
          0: '#ffffff',
          50: '{tala.50}',
          100: '{tala.100}',
          200: '{tala.200}',
          300: '{tala.300}',
          400: '{tala.400}',
          500: '{tala.500}',
          600: '{tala.600}',
          700: '{tala.700}',
          800: '{tala.800}',
          900: '{tala.900}',
          950: '{tala.950}',
        },
        primary: {
          color: '{tala.50}',
          contrastColor: '{tala.950}',
          hoverColor: '{tala.100}',
          activeColor: '{tala.200}',
        },
        highlight: {
          background: 'rgba(250, 250, 250, .16)',
          focusBackground: 'rgba(250, 250, 250, .24)',
          color: 'rgba(255,255,255,.87)',
          focusColor: 'rgba(255,255,255,.87)',
        },
      },
    },
  },
  mistbelle: {
    neutralSoft: '#f5efe6',
    neutralSoftStrong: '#f2e3d2',
    neutralWarm: '#eed7bd',
    brandMuted: '#a0703f',
    brandMutedAlt: '#af835c',
    brandStrong: '#714824',
    brandStrongAlt: '#6f4a2a',
    brandDeep: '#604228',
    textSoft: '#8b6644',
    action: '#a87443',
    actionText: '#8a5b32',
    actionTextAlt: '#8a633e',
    brandHighlight: '#b8814c',
    brandHighlightSoft: '#f6e2ce',
    brandHighlightMuted: '#fbead9',
    brandHighlightText: '#8e6038',
    brandGlow: '#d2a372',
  },
});
